import { render, staticRenderFns } from "./Prescribers.vue?vue&type=template&id=c1af8454&scoped=true&"
import script from "./Prescribers.vue?vue&type=script&lang=ts&"
export * from "./Prescribers.vue?vue&type=script&lang=ts&"
import style0 from "./Prescribers.vue?vue&type=style&index=0&id=c1af8454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1af8454",
  null
  
)

export default component.exports